import React, { useState, useEffect } from 'react';

import styles from './TimedButton.module.scss';
import PropTypes from 'prop-types';
import Button from '../Button/Button';

const TimedButton = ({ time, onClick, children, ...props }) => {
  const [startTime] = useState(Date.now());
  const [progress, setProgress] = useState(1);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    const tick = () => {
      const endTime = startTime + time;
      const newProgress = Math.max((endTime - Date.now()) / time, 0);
      setProgress(newProgress);
      if (newProgress <= 0) {
        window.clearInterval(tick);
      }
    };
    window.setInterval(tick);
    return () => {
      window.clearInterval(tick);
    };
  }, [startTime, time]);

  useEffect(() => {
    if (progress <= 0 && !clicked) {
      setClicked(true);
      onClick();
    }
  }, [clicked, progress, onClick]);

  return (
    <div className={styles.timed} {...props} onClick={onClick}>
      <Button alternative>{children}</Button>
      <div className={styles.bar} style={{ width: `${progress * 100}%` }}>
        <Button>{children}</Button>
      </div>
    </div>
  );
};

TimedButton.propTypes = {
  time: PropTypes.number,
  onClick: PropTypes.func,
};

TimedButton.defaultProps = {
  time: 10000,
  onClick: null,
};

export default TimedButton;
